export var ConnectionState;
(function (ConnectionState) {
    ConnectionState["DISCONNECTED"] = "DISCONNECTED";
    ConnectionState["CONNECTING"] = "CONNECTING";
    ConnectionState["CONNECTED"] = "CONNECTED";
    ConnectionState["RECONNECTING"] = "RECONNECTING";
    ConnectionState["ERROR"] = "ERROR";
})(ConnectionState || (ConnectionState = {}));
//# sourceMappingURL=websocket-client-types.js.map